import React from "react";
import {Row, Col} from "react-bootstrap";
import {getUsefulDate} from "../../common/utils.js";
import {translate} from '../../i18n/translate.js';

class SummaryDistributionDate extends React.Component {
    render() {
        return(
            <Row>
                <Col md={12}>
                    {/*<Col md={10}><b> {this.props.deliveryDateLabel} </b>  {getUsefulDate(this.props.nextDeliveryDate)}</Col>*/}
                    <div className="summary-section-title">
                        {translate(this.props.deliveryDateLabel)}
                    </div>
                    <div className="summary-content summary-distribution">
                        {getUsefulDate(this.props.nextDeliveryDate)}
                    </div>
                </Col>
            </Row>
        )
    }
}

export default SummaryDistributionDate;



// WEBPACK FOOTER //
// ./src/components/summary/SummaryDistributionDate.js